export default __webpack_public_path__ + "static/media/spooky_hill_l1.bb9d20f2.png";